import { format, parseISO } from "date-fns";

const amountFormatter = new Intl.NumberFormat("tr-TR", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const quantityFormatter = new Intl.NumberFormat("tr-TR", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
});

export function formatAmount(value: string | number | null | undefined): string {
	if (value === null || value === undefined || value === "") return "-";
	const num = typeof value === "string" ? parseFloat(value) : value;
	if (isNaN(num)) return "-";
	return amountFormatter.format(num);
}

export function formatQuantity(value: string | number | null | undefined): string {
	if (value === null || value === undefined || value === "") return "-";
	const num = typeof value === "string" ? parseFloat(value) : value;
	if (isNaN(num)) return "-";
	return quantityFormatter.format(num);
}

export function formatDate(value: string | Date | null | undefined): string {
	if (!value) return "—";
	const date = typeof value === "string" ? parseISO(value) : value;
	return format(date, "dd/MM/yyyy");
}

export function formatDateTime(value: string | Date | null | undefined): string {
	if (!value) return "—";
	const date = typeof value === "string" ? parseISO(value) : value;
	return format(date, "dd/MM/yyyy HH:mm");
}
